export enum PLUGIN_NAME_ENUM {
  MESSAGING = "messaging",
  PROJECT = "project",
  FORUM = "forum",
  INTERVIEW = "interview",
  WIKI = "wiki",
  DOCUMENTS = "documents",
  SETTINGS = "settings",
  PROFILE = "profile",
  MCP = "mcp",
}
